import type { Role } from "./enums";

export const STAFF_ROLES = ["internalAdmin", "markupAdmin"] as const satisfies readonly Role[];
export type StaffRole = (typeof STAFF_ROLES)[number];

const STAFF_ROLE_SET: ReadonlySet<Role> = new Set<Role>(STAFF_ROLES);

export const roleIsStaff = (role: Role | null | undefined): role is StaffRole =>
  role !== null && role !== undefined && STAFF_ROLE_SET.has(role);

export const roleCanManageClientUsers = (role: Role | null | undefined): boolean =>
  role === "clientAdmin" || roleIsStaff(role);

export const roleCanWriteCompanyData = (role: Role | null | undefined): boolean =>
  role !== null && role !== undefined && role !== "clientReadOnly";

export type UserActiveState = {
  readonly active?: boolean | null;
};

export type UserAccessState = UserActiveState & {
  readonly role: Role;
};

export const userIsActive = <User extends UserActiveState>(user: User | null | undefined): user is User =>
  user !== null && user !== undefined && user.active !== false;

export const userIsClient = (user: UserAccessState | null | undefined): user is UserAccessState =>
  user !== null && user !== undefined && !roleIsStaff(user.role);

export const userIsActiveClient = (user: UserAccessState | null | undefined): user is UserAccessState =>
  userIsClient(user) && userIsActive(user);

export const userCanManageClientUsers = (user: UserAccessState | null | undefined): user is UserAccessState =>
  userIsActive(user) && roleCanManageClientUsers(user.role);
